import React, { useEffect, useContext, useState, Suspense, lazy } from "react";

import { useParams, useLocation, Link } from "react-router-dom";

import {
  Container,
  Grid,
  Tooltip,
  Menu,
  MenuItem,
  FormGroup,
  FormControlLabel,
  Switch,
  Button,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/styles";
import { Explicit } from "@material-ui/icons";
import { EqualHeight } from "react-equal-height";

import InView from "../misc/InView";

import PlayCard from "./cards/PlayCard";
import SongFavorite from "./parts/SongFavorite";
import ShuffleStations from "./modals/ShuffleStations";
import CustomizeStation from "./modals/CustomizeStation";

const VarietySlider = lazy(() =>
  import(/* webpackChunkName: "vrtsldr" */ "../player/variety_slider.js.jsx")
);
const BanMessage = lazy(() =>
  import(/* webpackChunkName: "bnmssg" */ "./parts/BanMessage")
);
const TuneInMessage = lazy(() =>
  import(/* webpackChunkName: "timssg" */ "./parts/TuneInMessage")
);
const SongRadioMessage = lazy(() =>
  import(/* webpackChunkName: "srmssg" */ "./parts/SongRadioMessage")
);
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";
import { playerStoreContext } from "lib/player_store";

import PlayerMainRow from "../player/player_main_row.js.jsx";
import * as Vibrant from "node-vibrant";

import { v4 as uuidv4 } from "uuid";

import { tunein } from "lib/player_util";
import { disableScroll, enableScroll } from "lib/util";

import { postJSON } from "lib/ajax";

const NowPlaying = observer(({ skip }) => {
  const { artist: pageArtist } = useParams();
  const location = useLocation();
  const theme = useTheme();
  const mediumDown = useMediaQuery(theme.breakpoints.down("sm"));

  const setPlayerBG = (event) => {
    //console.log("setPlayerBG", event, event.currentTarget, event.currentTarget.currentSrc, event.currentTarget.src);
    //event?.stopPropagation();

    // const target = document.querySelector("#player_album_art");
    const img = event.currentTarget;
    // vibrant uses crossorigin if passed a string
    // img.src if passed element
    getPalette(img).catch((error) => {
      console.error("VIBRANT ERROR", error, img);
      getPalette(`${img.currentSrc || img.src}?i=1`).catch((error) => {
        console.error("VIBRANT ERROR", error, img);
        store.set_albumArtPalette(store.defaultAlbumArtPalette);
      });
      //throw error;
    });
  };

  const getPalette = (imgSrc) => {
    return Vibrant.from(imgSrc)
      .getPalette()
      .then((palette) => {
        store.set_albumArtPalette({
          light: palette.LightMuted.rgb.map((x) => parseInt(x, 10)),
          dark: palette.Muted.rgb.map((x) => parseInt(x, 10)),
        });
      });
  };

  const store = useContext(playerStoreContext);

  const {
    songInfo: { _song, similar_stations, artist },
    firstLoad,
    landingPathname,
  } = store;

  useEffect(() => {
    console.log("NowPlaying onMount");
    return () => {
      console.log("NowPlaying onUnmount");
    };
  }, []);

  // hide if visiting an artist page that is not playing
  // support landing on an artist page and playing that artist with <NowPlaying> visible
  console.log(
    "pageArtist",
    pageArtist,
    artist,
    "location.pathname",
    location.pathname,
    "landingPathname",
    landingPathname
  );
  if (
    !firstLoad &&
    landingPathname !== location.pathname &&
    location.pathname !== "/"
  ) {
    console.log("NowPlaying returning blank");
    return "";
  }

  return (
    <PlayerMainRow>
      <div
        id="now-playing"
        className="dark-bg container-standard"
        style={{ minHeight: "550px" }}
      >
        <Container>
          <Grid container className="align-items-center">
            <Grid item xs={12} md={true}>
              <NowPlayingSong albumArtOnLoad={setPlayerBG} skip={skip} />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              className={`currentStation-${mediumDown ? "xs" : "md"}`}
            >
              <CurrentStation skip={skip} />
            </Grid>
            <Grid item xs={12} md={true}>
              <InView>
                <RelatedStations stations={similar_stations} />
              </InView>
            </Grid>
          </Grid>
        </Container>
      </div>
    </PlayerMainRow>
  );
});

const NowPlayingSong = observer(({ albumArtOnLoad, skip }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [banMessageOpen, setBanMessageOpen] = useState(false);
  const [tuneinSnackOpen, setTuneinSnackOpen] = useState(false);
  const [songRadioSnackOpen, setSongRadioSnackOpen] = useState(false);

  const store = useContext(playerStoreContext);

  const {
    songInfo: {
      song,
      artist,
      song_id,
      favorite,
      has_radio,
      station_id,
      artist_station_id,
      station_name,
      album_art,
      album_art_srcset,
    },
    user_id,
  } = store;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    disableScroll();
  };

  const handleClose = () => {
    setAnchorEl(null);
    enableScroll();
  };

  const handleSongFavorite = () => {
    postJSON({
      url: "/song_ratings/add_favorite",
      data: {
        song_id: song_id,
      },
    }).then(() => {
      store.setSongFavorite(true);
      faveMessage();
    });
    handleClose();
  };

  const faveMessage = ({ isFavorite, _song_id }) => {
    if (isFavorite) {
      store.setFaveSnackOpen(true);
    }
  };

  const handleSongBan = () => {
    postJSON({
      url: "/song_ratings/add_ban",
      data: {
        song_id: song_id,
      },
    }).then(() => {
      store.setSongFavorite(false);
    });
    setBanMessageOpen(true);
    setTimeout(() => {
      skip();
    }, 2000);
    handleClose();
  };

  const song_radio_tunein = (e) => {
    e?.preventDefault();
    setSongRadioSnackOpen(true);

    return tunein(null, null, null, song_id, true);
  };

  const artist_radio_tunein = (e) => {
    e?.preventDefault();
    setTuneinSnackOpen(true);
    return tunein(artist_station_id, null, null, null, true);
  };

  return (
    <div style={{ position: "relative" }}>
      <div className="no_jump_wrapper">
        {/* i=1 to defeat cache for error: origin https://www.jango.com is not allowed by Access-Control-Allow-Origin */}
        <img
          fetchpriority="high"
          onLoad={albumArtOnLoad}
          src={album_art}
          srcSet={album_art_srcset}
          className="main-image"
        />
      </div>
      <Grid container className="align-items-center pt-2">
        <Grid item id="now-playing-heart" className="pr-4 pl-2">
          <SongFavorite
            song_id={song_id}
            favorite={favorite}
            callback={faveMessage}
          />
        </Grid>
        <Grid item xs>
          <h3 className="player-heading">Now Playing</h3>
          <p>
            {has_radio ? (
              <Tooltip title={`Launch '${song}' Radio`}>
                <span className="click-underline" onClick={song_radio_tunein}>
                  {song}
                </span>
              </Tooltip>
            ) : (
              <strong>{song}</strong>
            )}
            &nbsp;&nbsp;by&nbsp;&nbsp;
            {station_id == artist_station_id ? (
              <strong>{artist}</strong>
            ) : (
              <Tooltip title={`Launch ${artist} Radio`}>
                <span className="click-underline" onClick={artist_radio_tunein}>
                  {artist}
                </span>
              </Tooltip>
            )}
          </p>
        </Grid>
        <Grid
          item
          id="now-playing-ellipsis"
          className="pr-2 pl-2"
          aria-controls="now-playing-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <FontAwesomeIcon icon="ellipsis-v" className="icon-action" />
        </Grid>
      </Grid>
      <Menu
        disableScrollLock={true}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleSongFavorite}>Add song to favorites</MenuItem>
        <MenuItem onClick={handleSongBan}>Don't play again</MenuItem>
      </Menu>
      <Suspense fallback={null}>
        {banMessageOpen && (
          <BanMessage open={banMessageOpen} setOpen={setBanMessageOpen} />
        )}
      </Suspense>
      <Suspense fallback={null}>
        {tuneinSnackOpen && (
          <TuneInMessage
            open={tuneinSnackOpen}
            setOpen={setTuneinSnackOpen}
            station_name={station_name}
          />
        )}
      </Suspense>
      <Suspense fallback={null}>
        {songRadioSnackOpen && (
          <SongRadioMessage
            open={songRadioSnackOpen}
            setOpen={setSongRadioSnackOpen}
            song_id={song_id}
            station_name={station_name}
            user_id={user_id}
          />
        )}
      </Suspense>
    </div>
  );
});

const CurrentStation = observer(({ skip }) => {
  const store = useContext(playerStoreContext);

  const onExplicitChange = (e) => {
    //  console.log("change");
    const allow = e.target.checked;
    store.merge({ allow_explicit: allow });
    submitExplicit(allow);
  };

  const toggleExplicit = (_e) => {
    store.merge({ allow_explicit: !allow_explicit });
    submitExplicit(!allow_explicit);
  };

  const submitExplicit = (allow) => {
    postJSON({
      url: "/players/allow_explicit",
      data: { allow_explicit: allow },
    }).then(() => {
      if (!allow && store.song_explicit) {
        skip();
      }
    });
  };

  const {
    albumArtPalette,
    user_id,
    songInfo: {
      station_type,
      station_name,
      allow_explicit,
      artist_id,
      song_id,
      station_id,
      oid,
      oname,
    },
  } = store;

  return (
    <div className="pl-md-5" id="current-station">
      <Grid container alignItems="center">
        <CustomizeStation
          station_type={station_type}
          is_owner={oid == user_id || (user_id == 0 && station_id.length == 32)}
          station_id={station_id}
          user_id={user_id}
        />
        <Grid item className="pr-md-4" xs>
          <h3 className="player-heading">Current Station</h3>

          <h1 className="mt-2">
            <Link to={`/stations/${station_id}`}>
              {station_name}
              {oname && (
                <div style={{ fontSize: "0.9rem", fontFamily: "Roboto" }}>
                  Curated by {oname}
                </div>
              )}
            </Link>
          </h1>
        </Grid>
      </Grid>
      <Grid container alignItems="center">
        <Grid item className="pr-4">
          <Suspense fallback={null}>
            <VarietySlider knobColor={toJS(albumArtPalette.light)} />
          </Suspense>
        </Grid>
        <Grid item xs>
          <Grid container spacing={0} alignItems="center">
            <Grid item>
              <ShuffleSwitch />
            </Grid>
            <Grid item xs>
              <ShuffleStations />
            </Grid>
          </Grid>
          <Grid container spacing={0} alignItems="center">
            <Grid item>
              <SwitchDial
                checked={allow_explicit}
                onChange={onExplicitChange}
              />
            </Grid>
            <Grid item xs>
              <div
                className="hover-link"
                style={{ display: "inline-block" }}
                onClick={toggleExplicit}
              >
                Allow Explicit Songs
              </div>
              {!allow_explicit && (
                <ExplicitMenu artist_id={artist_id} song_id={song_id} />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
});

const ExplicitMenu = observer(({ artist_id, song_id }) => {
  const store = useContext(playerStoreContext);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    if (anchorEl) {
      return handleClose();
    }
    setAnchorEl(event.currentTarget);
    disableScroll();
  };

  const handleClose = () => {
    setAnchorEl(null);
    enableScroll();
  };

  const report = () => {
    const url = `/artists/${artist_id}/songs/${song_id}/report_explicit`;
    postJSON({ url: url }).then((data) => {
      store.merge({
        tags: store.songInfo.tags.concat("explicit"),
      });
      //      $.alertable.alert(data.message);
      store.setSnackCopy(data.message);
    });
  };

  return (
    <div
      onClick={handleClick}
      style={{
        cursor: "pointer",
        marginLeft: "0.5em",
        display: "inline-block",
        borderRadius: "0.2em",
        background: "rgba(0,0,0,0.3)",
        padding: "0.2em 0.5em",
      }}
    >
      <FontAwesomeIcon icon="ellipsis-v" className="icon-action" />
      <Menu
        disableScrollLock={true}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>
          Explicit lyrics in this song?
          <Button
            className="ml-4"
            variant="contained"
            color="secondary"
            startIcon={<Explicit />}
            onClick={report}
          >
            Report
          </Button>
        </MenuItem>
      </Menu>
    </div>
  );
});

// rerender of NowPlaying negates some clicks on ShuffleStations cards when toggling store.shuffle
const ShuffleSwitch = observer(() => {
  const store = useContext(playerStoreContext);

  const onShuffleChange = (e) => {
    const checked = e.target.checked;
    //console.log("Shuffle CHANGED", checked);

    store.setShuffle(checked);

    if (checked) {
      // guests set cookie to 2, delete on refresh/splash
      createCookie("_jsmix", _jm.user_id > 0 ? 1 : 2, 7, ".jango.com");
    } else {
      createCookie("_jsmix", 0, -1, ".jango.com");
    }
  };

  const { shuffle } = store;

  return <SwitchDial checked={shuffle} onChange={onShuffleChange} />;
});

const LightSwitch = withStyles({
  switchBase: {
    color: "rgb(200,200,200)",
    "&$checked": {
      color: "rgb(50,50,50)",
      "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
    },
    "&$checked + $track": {
      backgroundColor: "rgba(0,0,0,0.7)",
    },
  },
  //  focusVisible: {},
  checked: {},
  track: { backgroundColor: "rgba(0,0,0,0.5)" },
})(Switch);

const SwitchDial = ({ checked, onChange }) => {
  // const [state, setState] = React.useState({
  //   checked: true,
  // });

  // const handleChange = (event) => {
  //   setState({ ...state, [event.target.name]: event.target.checked });
  // };

  return (
    <FormGroup row>
      <FormControlLabel
        style={{ marginBottom: 0 }}
        control={
          <LightSwitch name="checked" checked={checked} onChange={onChange} />
        }
      />
    </FormGroup>
  );
};

// const GlobalStyle = createGlobalStyle`
//   #now-playing .card {
//   background-color: ${(props) => `rgb(${props.light.toString()})`};
//   :hover{ background-color: ${(props) => `rgb(${props.dark.toString()})`};
//   }
// `;

const RelatedStations = ({ stations }) => {
  // const store = useContext(playerStoreContext);
  // const {
  //   albumArtPalette: { light, dark },
  // } = store;

  return (
    <div id="related-stations">
      {/*      <GlobalStyle light={toJS(light)} dark={toJS(dark)} />
       */}{" "}
      <h3 className="mt-md-0 player-heading">Explore Stations</h3>
      <p className="player-subheading">
        Our picks for you based on your listening:
      </p>
      <EqualHeight>
        <Grid container className="card-container pt-2 pb-2" spacing={2}>
          {stations?.map(({ id, name, art }) => {
            return (
              <Grid key={uuidv4()} item xs={6}>
                <PlayCard title={name} image={art} station_id={id} />
              </Grid>
            );
          })}
        </Grid>
      </EqualHeight>
    </div>
  );
};

//import { createGlobalStyle } from "styled-components";
//import { playerStoreContext } from "lib/player_store";

export default NowPlaying;
